import * as Types from '@seeqdev/api/graphql/types';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { useGraphQLFetcher } from '@seeqdev/api';
export type GqlTemplateRuleInputFieldsFragment = { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined };

export type GqlResetTemplateDraftMutationVariables = Types.Exact<{
  input: Types.GqlResetTemplateDraftInput;
}>;


export type GqlResetTemplateDraftMutation = { __typename?: 'Mutation', resetTemplateDraft: { __typename?: 'TemplateDraft', id: string, sourceVersion: { __typename?: 'TemplateVersion', id: string, number: number } | undefined, template: { __typename?: 'Template', id: string, name: string, description: string | undefined, scopedTo: string | undefined, inputFeatures: Array<{ __typename?: 'TemplateInputFeature', id: string, canonicalId: string, name: string, description: string | undefined, outputType: Types.GqlFeatureOutputType, isRequired: boolean, outputItemType: string | undefined, outputItemMetadata: any | undefined }>, derivedFeatures: Array<{ __typename?: 'TemplateDerivedFeature', id: string, canonicalId: string, name: string, description: string | undefined, outputType: Types.GqlFeatureOutputType, isOutput: boolean, outputItemType: string | undefined, outputItemMetadata: any | undefined, rules: Array<
          | { __typename: 'TemplateBooleanConstantRule', staticValue: boolean | undefined, id: string, inputs: Array<{ __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }> }
          | { __typename: 'TemplateFormulaCreatorRule', id: string, formula: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }, parameters: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }, name: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }, description: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, scopedTo: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, identityId: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, permissionString: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, variableParameters: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, variableParameterStrings: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, inputs: Array<{ __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }> }
          | { __typename: 'TemplateNumericScalarCreatorRule', id: string, name: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }, description: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, scopedTo: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, identityId: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, permissionString: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, inputs: Array<{ __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }> }
          | { __typename: 'TemplateStringScalarCreatorRule', id: string, name: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }, description: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, scopedTo: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, identityId: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, permissionString: { __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined } | undefined, inputs: Array<{ __typename?: 'TemplateRuleInput', id: string | undefined, name: string, description: string | undefined, type: Types.GqlRuleInputTypeV1, inputFeatureId: string | undefined, argument: any | undefined }> }
        > }> } } };


export const TemplateRuleInputFieldsFragmentDoc = `
    fragment TemplateRuleInputFields on TemplateRuleInput {
  id
  name
  description
  type
  inputFeatureId
  argument
}
    `;
export const ResetTemplateDraftDocument = `
    mutation ResetTemplateDraft($input: ResetTemplateDraftInput!) {
  resetTemplateDraft(input: $input) {
    id
    sourceVersion {
      id
      number
    }
    template {
      id
      name
      description
      scopedTo
      inputFeatures {
        id
        canonicalId
        name
        description
        outputType
        isRequired
        outputItemType
        outputItemMetadata
      }
      derivedFeatures {
        id
        canonicalId
        name
        description
        outputType
        isOutput
        outputItemType
        outputItemMetadata
        rules {
          __typename
          id
          inputs {
            ...TemplateRuleInputFields
          }
          ... on TemplateFormulaCreatorRule {
            formula {
              ...TemplateRuleInputFields
            }
            parameters {
              ...TemplateRuleInputFields
            }
            name {
              ...TemplateRuleInputFields
            }
            description {
              ...TemplateRuleInputFields
            }
            scopedTo {
              ...TemplateRuleInputFields
            }
            identityId {
              ...TemplateRuleInputFields
            }
            permissionString {
              ...TemplateRuleInputFields
            }
            variableParameters {
              ...TemplateRuleInputFields
            }
            variableParameterStrings {
              ...TemplateRuleInputFields
            }
          }
          ... on TemplateStringScalarCreatorRule {
            name {
              ...TemplateRuleInputFields
            }
            description {
              ...TemplateRuleInputFields
            }
            scopedTo {
              ...TemplateRuleInputFields
            }
            identityId {
              ...TemplateRuleInputFields
            }
            permissionString {
              ...TemplateRuleInputFields
            }
          }
          ... on TemplateNumericScalarCreatorRule {
            name {
              ...TemplateRuleInputFields
            }
            description {
              ...TemplateRuleInputFields
            }
            scopedTo {
              ...TemplateRuleInputFields
            }
            identityId {
              ...TemplateRuleInputFields
            }
            permissionString {
              ...TemplateRuleInputFields
            }
          }
          ... on TemplateBooleanConstantRule {
            staticValue
          }
        }
      }
    }
  }
}
    ${TemplateRuleInputFieldsFragmentDoc}`;

export const useResetTemplateDraftMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GqlResetTemplateDraftMutation, TError, GqlResetTemplateDraftMutationVariables, TContext>) => {
    
    return useMutation<GqlResetTemplateDraftMutation, TError, GqlResetTemplateDraftMutationVariables, TContext>(
      {
    mutationKey: ['ResetTemplateDraft'],
    mutationFn: useGraphQLFetcher<GqlResetTemplateDraftMutation, GqlResetTemplateDraftMutationVariables>(ResetTemplateDraftDocument),
    ...options
  }
    )};
